<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    @click="confirm"
    data-testid="action-btn-reasignar"
  )
    b-spinner(v-if="loading" small)
    span(v-else) Reasignar
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

const PRESUPUESTO = 4

export default {
  name: 'ActionReasignar',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  computed: {
    nombreTecnico() {
      const tecnico = this.ot && this.ot.tecnico_asignado
      if (!tecnico) return 'técnico'
      const nombre = `${tecnico.first_name || ''} ${tecnico.last_name || ''}`.trim()
      return nombre || tecnico.email || 'técnico'
    },
    estadoPrevio() {
      const tipo = this.ot && this.ot.tipo_servicio
      const tipoId = tipo && typeof tipo === 'object' ? tipo.id : tipo
      const estadoNombre =
        this.ot && this.ot.estado && this.ot.estado.estado
          ? this.ot.estado.estado.nombre
          : ''
      if (tipoId === PRESUPUESTO && estadoNombre === 'En Reparación') {
        return 'Cotización Aceptada'
      }
      return 'Ingresado'
    },
    mensajeConfirmacion() {
      const nombre = this.nombreTecnico
      return (
        `El equipo se devolverá a Bodega, la OT se le quitará al técnico ${nombre}, ` +
        `volverá a ${this.estadoPrevio} y quedará con prioridad de asignación. ` +
        `El técnico ${nombre} no la recibirá de nuevo en la asignación automática. ¿Continuar?`
      )
    },
  },
  methods: {
    ...mapActions('OTStore', ['reasignarOT', 'getOT']),
    async confirm() {
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(this.mensajeConfirmacion, {
          title: 'Por favor Confirma',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'SÍ',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        if (!confirmed) return
        await this.executeWithLoading(async () => {
          await this.reasignarOT({ otId: this.ot.ot })
          this.$bvToast.toast('OT reasignada. Quedó en Bodega con prioridad de asignación.', {
            variant: 'success',
          })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
        })
      } catch (error) {
        console.error('Error al reasignar la OT:', error)
        this.$bvToast.toast('Error al reasignar la OT.', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
